define.alias("shared/components/shared/expandable-radio-card", "settings/components/shared/expandable-radio-card");